import simpleParallax from 'simple-parallax-js';
const parallaxBanner = () => {
    const parallaxBanners = document.querySelectorAll('[data-parallax-banner]');
    parallaxBanners.forEach((banner) => {
        const backgroundImage = banner.querySelector('[data-parallax-background]');
        if (backgroundImage) {
            new simpleParallax(backgroundImage, {
                scale: 1.6,
                delay: 0.5,
            });
        }
        const foregroundImage = banner.querySelector('[data-parallax-foreground]');
        if (foregroundImage) {
            new simpleParallax(foregroundImage, {
                scale: 1.1,
                delay: 0.5,
            });
        }
    });
};
export { parallaxBanner };
